
export const socialmediaicons = [
  {
    name: 'Facebook Circle',
    icon: 'icon icon-cta-facebook',
  },
  {
    name: 'Facebook',
    icon: 'icon icon-social-facebook',
  },
  {
    name: 'Twitter Circle',
    icon: 'icon icon-icon-cta-twitter-x',
  },
  {
    name: 'Twitter',
    icon: 'icon icon-social-twitter-x',
  },
  {
    name: 'Google Plus',
    icon: 'icon icon-social-google-plus',
  },
  {
    name: 'Google Plus Circle',
    icon: 'icon icon-cta-google-plus',
  },
  {
    name: 'Pinterest Circle',
    icon: 'icon icon-cta-pinterest',
  },
  {
    name: 'Pinterest',
    icon: 'icon icon-social-pinterest',
  },
  {
    name: 'Instagram Circle',
    icon: 'icon icon-cta-instagram',
  },
  {
    name: 'Instagram',
    icon: 'icon icon-social-instagram',
  },
  {
    name: 'Linkedin',
    icon: 'icon icon-social-linkedin',
  },
  {
    name: 'Yelp',
    icon: 'icon icon-social-yelp',
  },
  {
    name: 'Youtube',
    icon: 'icon icon-social-youtube',
  },
  {
    name: 'Facebook Official',
    icon: 'fa fa-facebook-official',
  },
  {
    name: 'Facebook Square',
    icon: 'fa fa-facebook-square',
  },
  {
    name: 'Google Plus Official',
    icon: 'fa fa-google-plus-official',
  },
  {
    name: 'Google Plus Square',
    icon: 'fa fa-google-plus-square',
  },
  {
    name: 'Linkedin Square',
    icon: 'fa fa-linkedin-square',
  },
  {
    name: 'Pinterest Square',
    icon: 'fa fa-pinterest-square',
  },
  {
    name: 'Skype',
    icon: 'fa fa-skype',
  },
  {
    name: 'Snapchat',
    icon: 'fa fa-snapchat',
  },
  {
    name: 'Snapchat Ghost',
    icon: 'fa fa-snapchat-ghost',
  },
  {
    name: 'Snapchat Square',
    icon: 'fa fa-snapchat-square',
  },
  {
    name: 'Tumblr',
    icon: 'fa fa-tumblr',
  },
  {
    name: 'Tumblr Square',
    icon: 'fa fa-tumblr-square',
  },
  {
    name: 'Vimeo',
    icon: 'fa fa-vimeo',
  },
  {
    name: 'Vimeo Square',
    icon: 'fa fa-vimeo-square',
  },
  {
    name: 'Youtube Play',
    icon: 'fa fa-youtube-play',
  },
  {
    name: 'Youtube Square',
    icon: 'fa fa-youtube-square',
  },
  {
    name: 'Vine',
    icon: 'fa fa-vine',
  },
  {
    name: 'Wordpress',
    icon: 'fa fa-wordpress',
  },
  {
    name: 'Four Square',
    icon: 'fa fa-foursquare',
  },
  {
    name: 'Google',
    icon: 'fa fa-google',
  },
];

export const mediaIconMap = {};
socialmediaicons.forEach(({ name, icon }) => {
  mediaIconMap[name] = icon;
});

export const mediaIconNames = socialmediaicons.map(({ name }) => name);
